import { render } from "./patient_login_list.vue?vue&type=template&id=7660766a&scoped=true"
import script from "./patient_login_list.vue?vue&type=script&lang=js"
export * from "./patient_login_list.vue?vue&type=script&lang=js"

import "./patient_login_list.vue?vue&type=style&index=0&id=7660766a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7660766a"]])

export default __exports__